import React, { forwardRef } from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Offscreen 1080x1080 meme card for Instagram/Twitter/Facebook export.
 * Rendered at a fixed pixel size (not responsive) so html-to-image produces
 * a predictable, share-ready square PNG.
 *
 * Ref is attached to the outer box so callers can capture it.
 */
const MemeCard = forwardRef(({ title, truthSnippet }, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        width: '1080px',
        height: '1080px',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: "'Anton', system-ui, sans-serif",
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Myth half */}
      <Box
        sx={{
          flex: 1,
          background: 'linear-gradient(135deg, #D7140F 0%, #ef5350 100%)',
          color: '#fff',
          padding: '64px 72px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Typography
          sx={{
            fontSize: '28px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '4px',
            opacity: 0.85,
            mb: 3,
          }}
        >
          The Myth
        </Typography>
        <Typography
          sx={{
            fontSize: '64px',
            fontWeight: 900,
            lineHeight: 1.1,
            fontFamily: "'Anton', system-ui, sans-serif",
            textDecoration: 'line-through',
            textDecorationThickness: '4px',
            textDecorationColor: 'rgba(255,255,255,0.55)',
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Truth half */}
      <Box
        sx={{
          flex: 1.1,
          backgroundColor: '#fff',
          padding: '64px 72px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Typography
          sx={{
            fontSize: '28px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '4px',
            color: '#2e7d32',
            mb: 3,
          }}
        >
          The Reality
        </Typography>
        <Typography
          sx={{
            fontSize: '40px',
            fontWeight: 600,
            lineHeight: 1.3,
            color: '#111111',
            fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
          }}
        >
          {truthSnippet}
        </Typography>
      </Box>

      {/* Brand footer */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 28,
          left: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: '22px',
            fontWeight: 900,
            color: '#111111',
            fontFamily: "'Anton', system-ui, sans-serif",
            letterSpacing: '2px',
            textTransform: 'uppercase',
          }}
        >
          EVs for Idiots
        </Typography>
        <Typography sx={{ fontSize: '18px', color: '#555555', fontWeight: 500 }}>
          evsforidiots.com
        </Typography>
      </Box>
    </Box>
  );
});

MemeCard.displayName = 'MemeCard';
export default MemeCard;
